import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { PromiseSection } from './components/PromiseSection';
import { BookPresentation } from './components/BookPresentation';
import { FivePillars } from './components/FivePillars';
import { BenefitsSection } from './components/BenefitsSection';
import { SocialProof } from './components/SocialProof';
import { OfferCTA } from './components/OfferCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-warm-dark font-body text-cream" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <PromiseSection data-id="element-3" />
      <BookPresentation data-id="element-4" />
      <FivePillars data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <SocialProof data-id="element-7" />
      <OfferCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}